<mbs-modal>
  <ng-container modal-body>
    <section class="d-flex flex-column mbs-remote-connection-prepare-modal-component_content">
      <ng-container [ngSwitch]="connectionMode$ | async">
        <ng-template [ngSwitchCase]="PrepareConnectionMode.Ready">
          <header class="mb-3 mt-4 pt-4">
            <h4 class="mb-0 d-flex justify-content-center align-items-center">
              <span>{{ 'shared:computers.connect.connectionReady' | i18next }}</span>
            </h4>
          </header>
          <p class="text-center mb-0">
            <span [innerHTML]="'shared:computers.connect:readyBody' | i18next"></span>
            <mbs-button
              type="link"
              [isCtrl]="true"
              (click)="connect(connectionType)">
              {{ 'shared:computers.connect.readyBodyLink' | i18next }}
            </mbs-button>
          </p>
          <p class="text-center mb-0 mt-3">
            {{ 'shared:computers.connect.ifConnectNotInstalled' | i18next }}
            <br />
            <a
              class="ctrl-primary"
              [href]="downloadLink"
              download
              >{{ 'shared:computers.connect.clickHere' | i18next }}</a
            >
            {{ 'shared:computers.connect.toDownloadAndInstall' | i18next }}
            <ng-container *ngIf="isAgentSupportWebRTC$ | async">
              <span [innerHTML]="'shared:computers.connect.orUse' | i18next"></span>
              <mbs-button
                [isCtrl]="true"
                (click)="connect(Type.WebRTC)">
                {{ 'shared:computers.connect.webVersion' | i18next }}
              </mbs-button>
            </ng-container>
          </p>
        </ng-template>
        <ng-template [ngSwitchCase]="PrepareConnectionMode.Preparation">
          <header class="mb-3 mt-4 pt-4">
            <h4 class="mb-0 d-flex justify-content-center align-items-center">
              <span>{{ 'shared:computers.connect.preparingConnection' | i18next }}</span>
            </h4>
          </header>
          <p class="text-x text-center pb-4">
            {{ 'shared:computers.connect.click' | i18next }}
            <strong>{{ 'shared:computers.connect.openConnect' | i18next }}</strong>
            {{ 'shared:computers.connect.inTheBrowserPopUp' | i18next }}
          </p>
          <div class="d-flex justify-content-center align-items-center">
            <div class="py-2">
              <span class="loader loader-lg"></span>
            </div>
          </div>
        </ng-template>
        <ng-template [ngSwitchCase]="PrepareConnectionMode.Installation">
          <header class="mb-3 mt-4 pt-4">
            <h4 class="mb-0 d-flex justify-content-center align-items-center">
              <span>{{ 'shared:computers.connect.installingApplication' | i18next }}</span>
            </h4>
          </header>
          <p class="text-x text-center pb-4">
            {{ 'shared:computers.connect.installingApplicationSubText' | i18next }}
          </p>
          <div class="d-flex justify-content-center align-items-center">
            <div class="py-2">
              <span class="loader loader-lg"></span>
            </div>
          </div>
        </ng-template>
        <ng-template [ngSwitchCase]="PrepareConnectionMode.Installed">
          <header class="mb-3 mt-4 pt-4">
            <h4 class="mb-0 d-flex justify-content-center align-items-center">
              <span>{{ 'shared:computers.connect.installationCompleted' | i18next }}</span>
            </h4>
          </header>
          <p class="text-x text-center pb-4">
            {{ 'shared:computers.connect.installationCompletedSubText1' | i18next }}
            <b>{{ 'shared:products.ra' | i18next }}</b>
            {{ 'shared:computers.connect.installationCompletedSubText2' | i18next }}
          </p>
          <div class="d-flex justify-content-center align-items-center">
            <div class="py-3">
              <mbs-button
                type="primary"
                (click)="connect(connectionType, true)">
                {{ 'shared:products.ra' | i18next }}
              </mbs-button>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </section>
  </ng-container>
</mbs-modal>
